'use client';

import {
  createContext,
  useContext,
  useMemo,
  type ReactNode,
} from 'react';

export const LISTING_NAV_START_EVENT = 'listing-nav-start';

/** Kept for Header category links; no longer triggers a loading placeholder. */
export function signalListingNavigation(_href?: string) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(LISTING_NAV_START_EVENT));
}

type ListingNavigationContextValue = {
  startListingNavigation: (href?: string) => void;
};

const ListingNavigationContext = createContext<ListingNavigationContextValue | null>(null);

export function useListingNavigation(): ListingNavigationContextValue {
  const ctx = useContext(ListingNavigationContext);
  if (!ctx) {
    return { startListingNavigation: () => {} };
  }
  return ctx;
}

const noopNavigation = () => {};

export function ListingNavigationProvider({ children }: { children: ReactNode }) {
  const value = useMemo(
    () => ({ startListingNavigation: noopNavigation }),
    [],
  );

  return (
    <ListingNavigationContext.Provider value={value}>
      {children}
    </ListingNavigationContext.Provider>
  );
}
